import { makeStyles } from '@mui/styles';

export const useCssClasses = makeStyles((theme: any) => ({
  root: {
    paddingBottom: '8px',
    textAlign: 'center',
  },
  dialogContentText: {
    fontFamily: 'Lanna',
    textAlign: 'center',
    '& span': {
      display: 'block',
      whiteSpace: 'pre-line',
    },
    [theme.breakpoints.up('sm')]: {
      '& span': {
        display: 'inline',
      },
      '& span:first-of-type': {
        display: 'block',
      },
      '& span:not(:last-child)::after': {
        content: '"\\a0"',
      },
    },
    '& .consent-rule': {
      textAlign: 'left',
    },
    '& ul': {
      marginTop: '5px',
    },
  },
  dialogActions: {
    justifyContent: 'center',
    '& button': {
      width: '161px',
    },
  },
}));
